import React from 'react'
import { IntlProvider } from 'react-intl'

import Layout from './layout'

import messages from '../../locale/en'
// import en from 'react-intl/locale-data/en'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/dist/locale-data/en'
import 'intl/locale-data/jsonp/en'
import 'intl-pluralrules'

// addLocaleData(en)

const LayoutEN = ({ children }) => (
  <IntlProvider locale="en" messages={messages}>
    <Layout>{children}</Layout>
  </IntlProvider>
)

export default LayoutEN
